export default {"src":"/_next/static/media/clock-4.70e7b8b7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};